module.exports = __webpack_public_path__ + "media/attack.b2c1e371.mp3";